import React from 'react';
import { Form, AutoSaveInput } from '@blueprintnyc/bpnyc-common';
import Select from 'components/Select';
import WidgetOptionsForm from './WidgetOptionsForm';
import WidgetOptionGroupPermissions from './WidgetOptionGroupPermissions';

const SocialWidgetOptions = props => {
	const {
		widgetToUpdate,
		handleChange,
		widgetProps,
		handlePropChange,
		event,
		handleGroupChange,
		targetKeys,
	} = props;

	return (
		<WidgetOptionsForm initialValues={widgetToUpdate.props} handleChange={handleChange}>
			<h4 className="admin-form-item-label">Select Display Type</h4>
			<Select
				data={[
					{ id: 'standard', name: 'Standard' },
					{ id: 'carousel', name: 'Carousel' },
				]}
				value={widgetProps && widgetProps.display ? [widgetProps.display] : ['standard']}
				onChange={v => handlePropChange('display')(v)}
				form={true}
			/>
			<Form.Item label="Hashtag" name="hashtag">
				<AutoSaveInput bufferTime={0} />
			</Form.Item>
			<Form.Item label="Include Widget Headers?" name="include_headers">
				<Form.TwoOptionSelect />
			</Form.Item>
			<WidgetOptionGroupPermissions
				event={event}
				handleGroupChange={handleGroupChange}
				targetKeys={targetKeys}
			/>
		</WidgetOptionsForm>
	);
};

export default SocialWidgetOptions;
